"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.Checkbox = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));

var _core = require("@material-ui/core");

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _excluded = ["dataQa", "color", "label", "disabled", "variant", "formControlLabelRootClass", "formControlLabelLabelClass", "checkboxRootClass", "size"];

var styles = function styles(theme) {
  return {
    emptyTextUtil: {
      '&::before': {
        content: '""',
        display: 'inline-block'
      }
    },
    formHelperText: {
      marginTop: theme.spacing(-0.375)
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * Selection component with checked/unchecked state.
 */

var Checkbox = function Checkbox(_ref) {
  var dataQa = _ref.dataQa,
      color = _ref.color,
      label = _ref.label,
      disabled = _ref.disabled,
      variant = _ref.variant,
      formControlLabelRootClass = _ref.formControlLabelRootClass,
      formControlLabelLabelClass = _ref.formControlLabelLabelClass,
      checkboxRootClass = _ref.checkboxRootClass,
      size = _ref.size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();

  var _useFormState = (0, _useFormState2["default"])(props),
      name = _useFormState.name,
      checked = _useFormState.checked,
      onChange = _useFormState.onChange,
      onBlur = _useFormState.onBlur,
      error = _useFormState.error,
      helperText = _useFormState.helperText;

  var icons = {
    circle: _RadioButtonUnchecked["default"]
  };
  var checkedIcons = {
    circle: _CheckCircle["default"]
  };
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    error: error,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    label: label,
    classes: {
      root: formControlLabelRootClass,
      label: formControlLabelLabelClass
    },
    control: /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      name: name,
      checked: checked,
      onChange: onChange,
      onBlur: onBlur,
      icon: icons[variant],
      checkedIcon: checkedIcons[variant],
      color: color,
      disabled: disabled,
      error: error,
      size: size,
      inputProps: {
        'data-qa': dataQa
      },
      classes: {
        root: checkboxRootClass
      }
    })
  }), /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
    className: classes.formHelperText
  }, helperText || /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.emptyTextUtil
  })));
};

exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  color: _propTypes["default"].oneOf(['primary', 'secondary']),

  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** If `true`, the component is checked. */
  checked: _propTypes["default"].bool.isRequired,

  /** The text to be used in an enclosing label element. */
  label: _propTypes["default"].node.isRequired,

  /** If `true`, the component is disabled. */
  disabled: _propTypes["default"].bool,

  /** Styles applied to the label's root component */
  formControlLabelRootClass: _propTypes["default"].object,

  /** Styles applied to the label's Typography component */
  formControlLabelLabelClass: _propTypes["default"].string,

  /** Styles applied to the checkbox's root component */
  checkboxRootClass: _propTypes["default"].string,

  /** The size of the checkbox. small is equivalent to the dense checkbox styling */
  size: _propTypes["default"].oneOf(['medium', 'small']),
  variant: _propTypes["default"].oneOf(['rounded', 'circle']),

  /**
   * Callback fired when the component is changed.
   *
   * **Signature:**
   * ```
   * function(event: object, checked: bool) => void
   * ```
   * *event*: The event source of the callback.
   * *checked*: The checked value of the checkbox.
   */
  onChange: _propTypes["default"].func
};
Checkbox.defaultProps = {
  color: 'primary',
  disabled: false,
  variant: 'rounded',
  enableHelperText: false,
  size: 'medium'
};
var _default = Checkbox;
exports["default"] = _default;